// @ts-nocheck
(function () {
  'use strict';

  const COLOR_KEYWORDS = ['color', 'colour'];
  const FILTER_SELECTORS = [
    '.product-media-container',
    '.dialog-thumbnails-list__thumbnail',
    '.slideshow-controls__thumbnail',
    'slideshow-slide',
  ];

  function norm(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function isColorName(name) {
    const n = norm(name);
    return COLOR_KEYWORDS.some((kw) => n.startsWith(kw) || n.includes('-' + kw + '-') || n === kw);
  }

  function getSelectedColor(root) {
    const checkedRadios = root.querySelectorAll('input[type="radio"]:checked');
    for (const radio of checkedRadios) {
      if (isColorName(radio.name)) return radio.value || radio.dataset.value || '';
    }
    const selects = root.querySelectorAll('select[name]');
    for (const select of selects) {
      if (isColorName(select.name)) return select.value || '';
    }
    const pressed = root.querySelectorAll('[aria-pressed="true"], [aria-checked="true"]');
    for (const el of pressed) {
      const name = el.name || el.getAttribute('data-option-name') || '';
      if (isColorName(name)) return el.value || el.dataset.value || el.textContent.trim() || '';
    }
    return '';
  }

  function applyFilter(root, color) {
    const normColor = norm(color);
    const hiddenSlideIndices = new Set();

    for (const selector of FILTER_SELECTORS) {
      const items = root.querySelectorAll(selector);
      for (const item of items) {
        const itemColor = norm(item.getAttribute('data-variant-color'));
        const shouldShow = !itemColor || itemColor === normColor || !normColor;
        if (shouldShow) {
          item.removeAttribute('hidden');
          item.classList.remove('zl-media-filtered-out');
        } else {
          item.setAttribute('hidden', '');
          item.classList.add('zl-media-filtered-out');
          if (item.tagName === 'SLIDESHOW-SLIDE') {
            const slideContainer = item.parentElement;
            if (slideContainer) {
              const slides = Array.from(slideContainer.children);
              const idx = slides.indexOf(item);
              if (idx >= 0) hiddenSlideIndices.add(idx);
            }
          }
          const slideIdx = item.getAttribute('data-slide-index');
          if (slideIdx !== null) hiddenSlideIndices.add(parseInt(slideIdx, 10));
        }
      }
    }

    const dotLists = root.querySelectorAll('.slideshow-controls__dots');
    for (const list of dotLists) {
      const dotLis = list.querySelectorAll(':scope > li');
      dotLis.forEach((li, idx) => {
        if (hiddenSlideIndices.has(idx)) {
          li.setAttribute('hidden', '');
          li.classList.add('zl-media-filtered-out');
        } else {
          li.removeAttribute('hidden');
          li.classList.remove('zl-media-filtered-out');
        }
      });
    }

    const counters = root.querySelectorAll('.slideshow-controls__counter');
    for (const counter of counters) {
      const totalSlideEl = root.querySelectorAll('slideshow-slide').length;
      const visibleCount = totalSlideEl - hiddenSlideIndices.size;
      const slashSpan = counter.querySelector('.slash');
      if (slashSpan && slashSpan.nextSibling) {
        slashSpan.nextSibling.textContent = String(visibleCount);
      }
    }
  }

  function initSection(section) {
    if (section.dataset.zlVariantFilterInit === 'true') return;
    section.dataset.zlVariantFilterInit = 'true';

    const initialColor = getSelectedColor(section);
    applyFilter(section, initialColor);
    section.querySelectorAll('media-gallery').forEach((g) => g.classList.add('zl-ready'));

    function createTransitionOverlay() {
      const gallery = section.querySelector('media-gallery');
      if (!gallery) return null;
      let mainImg = gallery.querySelector('slideshow-slide:not([hidden]):not([aria-hidden="true"]) img');
      if (!mainImg) mainImg = gallery.querySelector('.product-media-container:not([hidden]) img');
      if (!mainImg || !mainImg.src) return null;
      const galleryParent = gallery.parentElement;
      if (!galleryParent) return null;
      if (getComputedStyle(galleryParent).position === 'static') {
        galleryParent.style.position = 'relative';
      }
      const overlay = document.createElement('div');
      overlay.className = 'zl-transition-overlay';
      overlay.style.backgroundImage = `url("${mainImg.currentSrc || mainImg.src}")`;
      const galleryRect = gallery.getBoundingClientRect();
      overlay.style.aspectRatio = `${galleryRect.width} / ${galleryRect.height}`;
      galleryParent.appendChild(overlay);
      return overlay;
    }

    function lockProductInfoHeight() {
      const locked = [];
      const selectors = [
        '.product-information', '.product-information__details', '.product-information__form',
        '[ref="product-info"]', 'product-form-component', '.product-form-buttons', '.shopify-product-form',
      ];
      for (const sel of selectors) {
        const el = section.querySelector(sel);
        if (el instanceof HTMLElement && el.offsetHeight > 0 && !el.style.minHeight) {
          el.style.minHeight = el.offsetHeight + 'px';
          locked.push(el);
        }
      }
      return locked;
    }

    section.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) && !(target instanceof HTMLSelectElement)) return;
      if (!isColorName(target.name)) return;
      const overlay = createTransitionOverlay();
      const lockedElements = lockProductInfoHeight();
      section.classList.add('zl-variant-changing');
      setTimeout(() => {
        const color = getSelectedColor(section);
        applyFilter(section, color);
      }, 0);
      clearTimeout(section.__zlChangeTimeout);
      section.__zlChangeTimeout = setTimeout(() => {
        section.classList.remove('zl-variant-changing');
        if (overlay) {
          overlay.classList.add('zl-fade-out');
          setTimeout(() => overlay.remove(), 250);
        }
        setTimeout(() => {
          for (const el of lockedElements) el.style.minHeight = '';
        }, 100);
      }, 400);
    }, true);

    section.addEventListener('click', (event) => {
      const target = event.target && event.target.closest && event.target.closest('[aria-pressed], [aria-checked]');
      if (!target) return;
      setTimeout(() => {
        const color = getSelectedColor(section);
        applyFilter(section, color);
      }, 0);
    });

    const observer = new MutationObserver((mutations) => {
      let freshGallery = null;
      let needsRefilter = false;
      for (const mutation of mutations) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType !== 1) continue;
            const el = node;
            const gallery = el.matches?.('media-gallery') ? el : el.querySelector?.('media-gallery');
            if (gallery) {
              freshGallery = gallery;
              gallery.classList.add('zl-filtering-fresh');
              needsRefilter = true;
            } else if (
              el.matches?.('.product-media-container, .dialog-thumbnails-list__thumbnail') ||
              el.querySelector?.('.product-media-container, .dialog-thumbnails-list__thumbnail')
            ) {
              needsRefilter = true;
            }
          }
        }
      }
      if (needsRefilter) {
        const color = getSelectedColor(section);
        applyFilter(section, color);
        if (freshGallery) {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              freshGallery?.classList.add('zl-ready');
            });
          });
        }
      }
    });
    observer.observe(section, { childList: true, subtree: true });

    setTimeout(() => {
      section.querySelectorAll('media-gallery:not(.zl-ready)').forEach((g) => g.classList.add('zl-ready'));
    }, 1500);
  }

  function initAll() {
    const sections = document.querySelectorAll('.shopify-section');
    for (const section of sections) {
      if (section.querySelector('media-gallery, .product-media-container')) initSection(section);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
